export default "__VITE_ASSET__ix4YVHxc__"